import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[nrTreeselectAieaProp]',
  standalone: true,
})
export class NrTreeselectAieaPropDirective implements AfterViewInit {
  @Input() ariaRequired!: boolean;

  constructor(private _el: ElementRef) {}

  ngAfterViewInit() {
    const inputElement = this._el.nativeElement.querySelector(
      '.p-hidden-accessible > input[type="text"]',
    );
    inputElement?.setAttribute('aria-expanded', false);
    inputElement?.setAttribute('aria-required', this.ariaRequired);

    const buttonElement = this._el.nativeElement.querySelector('div > div[role="button"]');
    buttonElement?.setAttribute('aria-label', 'button');
  }
}
